module.exports = __webpack_public_path__ + "img/icon_copy.751e165d.png";